<template>
  <div class="auth-page">
    <b-container>
      <h5 class="auth-logo">
        <i class="fa fa-circle text-gray"></i>
        PageWatch.dev
        <i class="fa fa-circle text-warning"></i>
      </h5>
      <Widget class="widget-auth mx-auto" title="<h3 class='mt-0'>Register</h3>" customHeader>
        <p class="widget-auth-info">
            Use your email to sign up.
        </p>
        <form class="mt" @submit.prevent="register">
          <b-alert class="alert-sm" variant="danger" :show="!!errorMessage">
            {{errorMessage}}
          </b-alert>
          <div class="form-group">
            <input class="form-control no-border" ref="email" required type="email" name="email" placeholder="Email" />
          </div>
          <div class="form-group">
            <input class="form-control no-border" ref="password1" required type="password" name="password1" placeholder="Password" />
          </div>
          <div class="form-group">
            <input class="form-control no-border" ref="password2" required type="password" name="password2" placeholder="Confirm Password" />
          </div>
          <b-button type="submit" size="sm" class="auth-btn mb-3" variant="inverse">Register</b-button>
          <p class="widget-auth-info">or sign up with</p>
          <div class="social-buttons">
            <b-button variant="primary" class="social-button mb-2" @click="socialAuth('google')">
              <i class="social-icon social-google"></i>
              <p class="social-text">GOOGLE</p>
            </b-button>
            <b-button variant="primary" class="social-button mb-2" @click="socialAuth('github')">
              <i class="fa fa-github" style="font-size:20px;left:2px;color:black;background-color:white;padding:3px;border-radius:4px;position:absolute"></i>
              <p class="social-text">GITHUB</p>
            </b-button>

          </div>
        </form>
        <p class="widget-auth-info">
          Already have an account? Login instead.
        </p>
        <router-link class="d-block text-center" :to="{name: 'Login', query: {next: $route.query.next}}">Login</router-link>
      </Widget>
    </b-container>
    <footer class="auth-footer">
      2021 &copy; PageWatch.dev
    </footer>
  </div>
</template>

<script>
import Widget from '@/components/Widget/Widget';

export default {
  name: 'LoginPage',
  components: { Widget },
  data() {
    return {
      errorMessage: null,
    };
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Register - PageWatch.dev',
    // all titles will be injected into this template
  },
  methods: {
    socialAuth(provider) {
      this.errorMessage = '';
      if (this.$auth.isAuthenticated()) {
        this.$auth.logout();
      }

      this.$auth
              .authenticate(provider, {context: "register"})
              .then(r => {
                return this.$store.dispatch("reloadAll").then(() => {
                  if (this.$route.query.next && this.$route.query.next.startsWith('/admin/')){
                    window.location.replace(this.$route.query.next);
                  }
                  else {
                    window.location.replace('/admin/dashboard');
                  }
                });
              })
              .catch(error => {
                this.errorMessage = error.response.data.message;
                window.console.log(error);
              });
    },
    login(email, password) {
      return this.$auth
              .login({
                email: email,
                password:  password,
              })
              .then(r => {
                return this.$store.dispatch("reloadAll").then(() => {
                  if (this.$route.query.next && this.$route.query.next.startsWith('/admin/')){
                    window.location.replace(this.$route.query.next);
                  }
                  else {
                    window.location.replace('/admin/dashboard');
                  }
                });
              })
              .catch(error => {
                window.console.log(error);
                this.errorMessage = error.response.data.message;
                this.serverErrors = error.response.data;
                return false;
              })
              .finally(r => {
                this.loading = false;
              });

    },
    register() {
      this.errorMessage = '';
      if (this.$auth.isAuthenticated()) {
        this.$auth.logout();
      }
      this.$auth
              .register({
                email: this.$refs.email.value,
                password1:  this.$refs.password1.value,
                password2:  this.$refs.password2.value,
              })
              .then(r => {
                return this.login(this.$refs.email.value, this.$refs.password1.value);
              })
              .catch(error => {
                window.console.log(error)
                this.errorMessage = error.response.data.message;
                this.serverErrors = error.response.data;
              })
              .finally(r => {
                this.loading = false;
              });

    },
  },
  created() {

  },
};
</script>
